import angular from 'angular';
import { default as importDataService } from 'app/services/data/import.data.service';
import importMappingDialog from './importMappingDialog';
import controller from './import-document-dialog.controller';
import messagesTpl from './messages.required.html';
import template from './import-document-dialog.html';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  loaderService,
  ssDialogService,
} = library;

export class dialogService {
  getOptions($event, {
    customerId = -1,
    importTypeId = -1,
    title = '',
    entityId = -1,
    mimeType = '',
    fileName = '',
    refreshCallBack,
  }) {
    return {
      controller,
      controllerAs: 'importDialogVM',
      locals: {
        customerId,
        importTypeId,
        title,
        entityId,
        mimeType,
        fileName,
        refreshCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.global.importDocument.importDocumentDialog', [
  alerts,
  importDataService,
  importMappingDialog,
  loaderService,
  ssDialogService,
])
  .service('importDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('import-document.messages.html', messagesTpl);
  })
  .name;

console.log('app.components.global.importDocument.importDocumentDialog created');
